import template from './cost_center.html';
import controller from './cost_center.controller';
import './cost_center.scss';

let CostCenterComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
};

export default CostCenterComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/cost_center.component.js